import React from "react";

export default function UserAvatar({ name, size = "w-24 h-24", className = "" }) {
  // Extract first 2 words from name
  const getInitials = (fullName) => {
    if (!fullName) return "U";
    
    const words = fullName.trim().split(" ");
    if (words.length === 1) {
      return words[0].charAt(0).toUpperCase();
    }
    
    return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
  };

  const initials = getInitials(name);

  return (
    <div
      className={`${size} ${className} rounded-full bg-gradient-to-br from-primaryBlue to-blue-600 flex items-center justify-center text-white font-bold text-xl shadow-lg`}
    >
      {initials}
    </div>
  );
}
